import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBasketShopping } from '@fortawesome/free-solid-svg-icons';

import { setFlashMessage, useWebsite } from '../contexts/WebsiteContext';
import config from '../config/config';
import SupplierItem from '../components/SupplierItem';
import { useAuth } from '../contexts/AuthContext';
import { useMode } from '../contexts/ModeContext';

const { apiUrl } = config;
const apiPath = `${apiUrl}supplier`;

function SupplierList({ refreshList, isSubtitle }) {
    const [items, setItems] = useState([]);
    const { isModeAdmin } = useMode();
    const { website } = useWebsite();
    const { token } = useAuth();
    const { t } = useTranslation();

    // Get items from API
    const fetchItems = async () => {
        try {
            const response = await axios.get(`${apiPath}?website=${website}`);
            setItems(response.data);
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
        }
    };

    useEffect(() => {
        fetchItems();
    }, [refreshList]);

    const handleDelete = async (itemId) => {
        try {
            await axios.delete(`${apiPath}/${itemId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            fetchItems();
            setFlashMessage(t('SUCCESS_DELETED_MESSAGE'), 'success');
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
            console.error('An error occurred while deleting item:', error);
        }
    };

    const handleRankingUpdate = async (direction, itemId) => {
        try {
            await axios.put(
                `${apiPath}/${itemId}`,
                { ranking: direction }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            );
            fetchItems();
            setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success');
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
            console.error(`Error updating item ranking (${direction}):`, error);
        }
    };

    const handleEdit = async (itemId, editedSupplier) => {
        try {
            await axios.put(
                `${apiPath}/${itemId}`,
                editedSupplier, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            );
            fetchItems();
            setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success');
        } catch (error) {
            setFlashMessage(t('ERROR_MESSAGE'), 'error');
            console.error('Error updating item:', error);
        }
    };

    return (
        <>
            { isSubtitle && (isModeAdmin || (items && items.length > 0)) && <h2><FontAwesomeIcon icon={faBasketShopping} /> {t('SUPPLIERS')}</h2>}
            { (isModeAdmin && (!items || items.length === 0)) && <p>La liste des fournisseurs est vide</p>}
            {items.map((supplier, index) => (
                <SupplierItem
                    key={supplier.id}
                    supplier={supplier}
                    handleDelete={handleDelete}
                    handleEdit={handleEdit}
                    handleRankingUpdate={handleRankingUpdate}
                    isFirst={index === 0}
                    isLast={index === items.length - 1}
                />
            ))}
        </>
    );
}

export default SupplierList;
